<template>
  <div class="d-flex flex-column align-center flex-gap-8">
    <div v-if="isProUser" class="operation-approval-progress">
      <div
        class="operation-approval-progress__step operation-approval-progress__step--complete"
      >
        <v-avatar color="success" size="42"
          ><v-icon dark>mdi-check</v-icon></v-avatar
        >
        <span>{{ $t("instructions.uploadFiles.created") }}</span>
      </div>
      <div
        class="operation-approval-progress__line"
        :class="
          approved
            ? 'operation-approval-progress__line--completed'
            : 'operation-approval-progress__line--complete'
        "
      />
      <div
        class="operation-approval-progress__step"
        :class="
          approved
            ? 'operation-approval-progress__step--complete'
            : 'operation-approval-progress__step--active'
        "
      >
        <v-avatar :color="approved ? 'success' : 'primary'" size="42">
          <v-icon dark>{{ approved ? "mdi-check" : "mdi-bank" }}</v-icon>
        </v-avatar>
        <span>{{ $t("instructions.uploadFiles.bankReview") }}</span>
      </div>
      <div
        class="operation-approval-progress__line"
        :class="{ 'operation-approval-progress__line--activating': approved }"
      />
      <div
        class="operation-approval-progress__step"
        :class="{ 'operation-approval-progress__step--active': approved }"
      >
        <v-avatar :color="approved ? 'primary' : 'grey darken-2'" size="42"
          ><v-icon dark>mdi-currency-usd</v-icon></v-avatar
        >
        <span>{{ $t("instructions.uploadFiles.readyToQuote") }}</span>
      </div>
    </div>
    <v-alert
      color="primary"
      border="left"
      colored-border
      class="text-left"
      outlined
      elevation="0"
    >
      <div class="font-weight-medium">
        {{
          $t("instructions.uploadFiles.afterApproval", {
            operation: operationAlias,
          })
        }}
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "OperationApprovalProgress",
  props: { approved: { type: Boolean, default: false }, operationAlias: {type: String} },
  computed: {
    isProUser() {
      return (
        String(localStorage.getItem("userRole") || "").toLowerCase() === "pro"
      );
    },
  },
};
</script>

<style scoped>
.operation-approval-progress {
  align-items: flex-start;
  display: flex;
  justify-content: center;
  width: 100%;
}
.operation-approval-progress__step {
  align-items: center;
  display: flex;
  flex: 0 0 120px;
  flex-direction: column;
  gap: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
}
.operation-approval-progress__step--active span {
  color: var(--v-primary-base);
  font-weight: 700;
}
.operation-approval-progress__step--complete span {
  color: var(--v-success-base);
}
.operation-approval-progress__line {
  border-top: 2.4px dashed rgba(255, 255, 255, 0.25);
  flex: 1 1 70px;
  margin-top: 20px;
  max-width: 90px;
  position: relative;
}
.operation-approval-progress__line::after {
  border-top: 3px solid var(--v-success-base);
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: -2.4px;
  transform: scaleX(0);
  transform-origin: left;
}
.operation-approval-progress__line--complete::after {
  animation: operation-progress-stroke 1800ms ease-in-out infinite;
}
.operation-approval-progress__line--completed::after {
  transform: scaleX(1);
}
.operation-approval-progress__line--activating::after {
  animation: operation-progress-stroke 1800ms 250ms ease-in-out infinite;
  border-color: var(--v-primary-base);
}
@keyframes operation-progress-stroke {
  0% {
    transform: scaleX(0);
  }
  65%,
  100% {
    transform: scaleX(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .operation-approval-progress__line::after {
    animation-delay: 0ms;
    animation-duration: 1ms;
  }
}
@media (max-width: 600px) {
  .operation-approval-progress__step {
    flex-basis: 88px;
    font-size: 0.72rem;
  }
  .operation-approval-progress__line {
    min-width: 20px;
  }
}
</style>
